import initializeFormsComponents from "./components/forms/index";
import initializeClientSideValidations from "./components/forms/validation";

$(() => {
    initializeClientSideValidations();
    initializeFormsComponents();
});
